@if (validPrismicData) {
  <div class="flex justify-center items-center mt-2.5 mb-16 mx-4 margin-on-scroll" [id]="slice.sectionId">
    <lib-link [link]="slice.link" [attr.aria-label]="ariaLabel">
      <div class="flex">
        @if (slice.icon) {
          <div class="mr-2 mt-auto mb-auto">
            <lib-svg class="medium-responsive" [svg]="icon"></lib-svg>
          </div>
        }
        <div class="flex flex-col" [ngClass]="{ 'ml-4': !brand.isYallo() }">
          <div
            data-source="prismic"
            class="text-primary"
            [ngClass]="{ 'text-center': brand.isYallo() }"
            [innerHtml]="slice.phone_number"
          ></div>
          <div data-source="prismic" class="text-gray-1 text-center" [innerHtml]="slice.description"></div>
        </div>
      </div>
    </lib-link>
  </div>
}
